import React, { useEffect } from "react";
import {
  WA_CONNECTION_FAILURE_MESSAGE,
  broadcastWaAuth
} from "Pages/Dashboard/settings/ConnectedAccounts/WhatsAppAccounts/waConnectionMessages";

const WaFailure = () => {
  useEffect(() => {
    try {
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(WA_CONNECTION_FAILURE_MESSAGE, window.location.origin);
      }
    } catch (e) {
      // ignore
    }
    broadcastWaAuth(WA_CONNECTION_FAILURE_MESSAGE);
  }, []);

  return (
    <div className="waCallbackPage" style={{ padding: "40px 24px", textAlign: "center", fontFamily: "sans-serif" }}>
      <h2 style={{ color: "#c00", marginBottom: "12px" }}>Connection failed or was cancelled</h2>
      <p style={{ color: "#555", marginBottom: "12px", maxWidth: "360px", marginLeft: "auto", marginRight: "auto" }}>
        Close this tab with <strong>⌘W</strong> / <strong>Ctrl+W</strong> or use the button below, then try again from Connected Accounts.
      </p>
      <button
        type="button"
        onClick={() => {
          try {
            if (window.opener && !window.opener.closed) {
              window.opener.postMessage(WA_CONNECTION_FAILURE_MESSAGE, window.location.origin);
            }
          } catch (e) {
            // ignore
          }
          broadcastWaAuth(WA_CONNECTION_FAILURE_MESSAGE);
          try {
            window.close();
          } catch (e) {
            // ignore
          }
          try {
            const o = window.opener;
            if (o) o.focus();
          } catch (e) {
            // ignore
          }
        }}
        style={{
          padding: "10px 24px",
          background: "#666",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          fontSize: "14px"
        }}
      >
        Close window
      </button>
    </div>
  );
};

export default WaFailure;
export { WaFailure };
